import {
  COL_FILTER_HEADER_ACCOUNT,
  COL_FILTER_HEADER_CHILD_ENTITLEMENT,
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  COL_FILTER_HEADER_USER,
} from '../constant';

export const MAX_LEVEL_FOR_ROWS_FILTER = 2;

export {
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  FIXED_COL_FOR_ACCOUNT,
  FIXED_COL_FOR_CHILD_ENTITLEMENT,
  FIXED_COL_FOR_ENTITLEMENT,
  FIXED_COL_FOR_ROLE,
  FIXED_COL_FOR_USER,
} from '../constant';

export const CERT_TILE_TYPE = {
  USER: COL_FILTER_HEADER_USER,
  ROLE: COL_FILTER_HEADER_ROLE,
  ACCOUNT: COL_FILTER_HEADER_ACCOUNT,
  ENTITLEMENT: COL_FILTER_HEADER_ENTITLEMENT,
  CHILD_ENTITLEMENT: COL_FILTER_HEADER_CHILD_ENTITLEMENT,
};

export const CERT_ENTITLEMENT_VALUEKEY = {
  USER: '-4',
  ROLE: '-2',
  ACCOUNT: '0',
  ENTITLEMENT: 1, // any >= 0
};

// EO campaign constants
export const CERT_EO_CAMPAIGN_ROW_TYPE = {
  ENTITLEMENT: '0',
  ACCOUNT: '1',
  CHILD_ENTITLEMENT: '-1',
};
